import { useGetIdentity } from "@pankod/refine-core";
import { gql, GraphQLClient } from "graphql-request";
import { nhost } from "utility";

export const getAllUsers = async () => {
  let QUERY = `query {
  users(order_by: {createdAt: desc}) {
    id
    displayName
    email
    metadata
    defaultRole
    createdAt
    updatedAt
    lastSeen
    disabled
    avatarUrl
  }
}`;
  const { data } = await nhost.graphql.request(QUERY);
  return data;
};
export const getOpenApiPermissionUsers = async (limit: number, offset: number, searchValue: any) => {
  try {
    let QUERY = ''
    if (searchValue !== '') {
      QUERY = `query getAiPermissionUsers{
  users(where:{displayName:{_ilike:"${searchValue}%"},ai_permission: {_eq: true},disabled:{_eq:false}}){
  id
  displayName
  email
  defaultRole
  },
  usersAggregate(where:{displayName:{_ilike:"${searchValue}%"},ai_permission: {_eq: true},disabled:{_eq:false}}){
    aggregate{
      count
    }
  }
  }`
    } else {
      QUERY = `query getAiPermissionUsers{
    users(order_by:{createdAt:desc},limit:${limit},offset:${offset},where:{displayName:{_ilike:"${searchValue}%"},ai_permission: {_eq: true},disabled:{_eq:false}}){
    id
    displayName
    email
    defaultRole
    },
    usersAggregate(where:{displayName:{_ilike:"${searchValue}%"},ai_permission: {_eq: true},disabled:{_eq:false}}){
    aggregate{
      count
    }
  }
    }`
    }

    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err)
  }
}
export const getUsersList = async (limit: number, offset: number, condition: any, searchValue: any) => {
  let QUERY = ''
  if (searchValue !== '') {
    QUERY = `query getUsersList {
  users( where:{${condition},displayName:{_ilike:"${searchValue}%"}},order_by: {createdAt: desc}) {
    id
    displayName
    email
    emailVerified
    metadata
    defaultRole
    createdAt
    updatedAt
    lastSeen
    disabled
    ai_permission
    avatarUrl
      roles {
     
        role
      
    }
  },
    usersAggregate( where:{${condition},displayName:{_ilike:"${searchValue}%"}}){
    aggregate{
      count
    }
  }
}`;
  }
  else {
    QUERY = `query getUsersList {
  users( where:{${condition},displayName:{_ilike:"${searchValue}%"}},order_by: {createdAt: desc},limit:${limit},offset:${offset}) {
    id
    displayName
    email
    emailVerified
    metadata
    defaultRole
    createdAt
    updatedAt
    lastSeen
    disabled
    avatarUrl
      roles {
     
        role
      
    }
  },
    usersAggregate( where:{${condition},displayName:{_ilike:"${searchValue}%"}}){
    aggregate{
      count
    }
  }
}`;
  }
  const { data } = await nhost.graphql.request(QUERY);
  return data;
  //  userRoleManagement{
  //     id
  //     user_id
  //     roles
  //   }
  // }
}
export const getUsersListAdmin = async (limit: number, offset: number, searchValue: any) => {
  let QUERY = ''
  if (searchValue !== '') {
    QUERY = `query getUsersListAdmin{
  users(where:{displayName:{_ilike:"${searchValue}%"}}) {
    id
    displayName
    email
    emailVerified
    metadata
    defaultRole
    createdAt
    updatedAt
    lastSeen
    disabled
    avatarUrl
      roles {
     
        role
      
    }
  },
    usersAggregate(where:{displayName:{_ilike:"${searchValue}%"}}){
    aggregate{
      count
    }
  }
}`;
  }
  else {
    QUERY = `query getUsersListAdmin{
  users(order_by: {createdAt: desc},limit:${limit},offset:${offset},where:{displayName:{_ilike:"${searchValue}%"}}) {
    id
    displayName
    email
    emailVerified
    metadata
    defaultRole
    createdAt
    updatedAt
    lastSeen
    disabled
    avatarUrl
      roles {
     
        role
      
    }
  },
    usersAggregate(where:{displayName:{_ilike:"${searchValue}%"}}){
    aggregate{
      count
    }
  }
}`;
  }
  const { data } = await nhost.graphql.request(QUERY);
  return data;
  //  userRoleManagement{
  //     id
  //     user_id
  //     roles
  //   }
  // }
}

export const getUsersByRole = async (role: string) => {
  let QUERY = `query {
 
  authUserRoles(where:{role:{_eq:${role}},user:{disabled:{_eq:false}}},order_by:{user:{displayName:asc}}){
    id
    role
    user{
       id
    displayName
    email
    metadata
    defaultRole
    createdAt
    updatedAt
    lastSeen
    disabled
    avatarUrl
    }
  }
}`;

  const { data } = await nhost.graphql.request(QUERY);
  return data;
};
export const getUsersByRoleSearch = async (role: string, searchValue: string) => {
  let QUERY = `query {
 
  authUserRoles(where:{role:{_eq:${role}},user:{displayName:{_ilike:"${searchValue}%"}}},,order_by:{user:{displayName:asc}}){
    id
    role
    user{
       id
    displayName
    email
    metadata
    defaultRole
    createdAt
    updatedAt
    lastSeen
    disabled
    avatarUrl
    }
  }
}`;

  const { data } = await nhost.graphql.request(QUERY);
  return data;
};
export const getUsersById = async (uuid: string) => {
  let QUERY = `query {
         users(where: {id: {_eq:"${uuid}"}}) {
          id
          displayName
          email
          defaultRole
          ai_permission
  }
}`;
  const { data, error } = await nhost.graphql.request(QUERY);
  console.log(error, 'error is this')
  return data;
};

export const getAllRoles = async () => {
  let QUERY = `query {
    authRoles(where:{role:{_nin:["user","me"]}}) {
    role,

  }
}`;
  const { data } = await nhost.graphql.request(QUERY);
  return data;
};
export const getLastCreatedUser = async () => {
  let QUERY = `query {
   users(limit: 1, order_by: {createdAt: desc}) {
    displayName
    createdAt
    id
  }
}`;
  const { data } = await nhost.graphql.request(QUERY);
  return data;
};
export const updateUserRoles = async (user_id: string, roles: any, updated_by: any) => {
  let QUERY = gql`mutation update {
  update_user_role_management(where: {user_id:{_eq:"${user_id}"}},_set:{roles:"${roles}",updated_by:"${updated_by}"}){
    returning{
      id
    }
  }
}`;
  const { data } = await nhost.graphql.request(QUERY);
  return data;
}
export const updateUserRole = async (user_id: string, role: string) => {

  let QUERY = gql`mutation insertAuthUserRole {
  insertAuthUserRole(
    object: {
      userId:"${user_id}", role: "${role}"
    }
  ) {
    id
    role
  }
}`;
  const { data } = await nhost.graphql.request(QUERY);
  return data;
};
export const updateUser = async (user_id: string, role: string) => {
  let QUERY = gql`mutation update {
  updateUsers(where: {id:{_eq:"${user_id}"}},_set:{defaultRole:"${role}"}){
    returning{
      id
    }
  }
}
`;
  const { data } = await nhost.graphql.request(QUERY);
  return data;
};
export const createUser = async ({
  email,
  password,
  defaultRole,
  displayName,
  created_by,
  roles
}: {
  email: string;
  password: string;
  defaultRole: string;
  displayName: string;
  created_by: string;
  roles: string[];

}) => {

  const { error } = await nhost.auth.signUp({
    email: email,
    password: password,
    options: {
      defaultRole: "user",
      displayName: displayName,
      redirectTo: `${process.env.REACT_APP_PRODUCTION_URL}/changepassword`
    },
  });
  if (error) {
    return Promise.resolve(error?.message);
  } else {
    getLastCreatedUser().then((response: any) => {
      roles.length > 0 && roles.map((item: any) => {
        updateUserRole(response?.users[0]?.id, item).then((resp) => {
          updateUser(response?.users[0]?.id, defaultRole).then(res => {
          })
        })

      });
      // nhost.auth.
      //   nhost.auth.sendVerificationEmail({
      //     email: email,
      //     options: {
      //   redirectTo: 'https://centa-ams1-dev.netlify.app/login'
      // },})
    });
    return Promise.resolve("OK");
  }
};
export const createUserRoles = async (id: string, roleIds: any, created_by: string) => {


  let QUERY = gql`mutation insert_user_role_management_one {
  insert_user_role_management_one(
    object: {
      user_id:"${id}", roles: "${roleIds}",created_by:"${created_by}"
    }
  ) {
    id
    roles
  }
}`;
  const { data } = await nhost.graphql.request(QUERY);
  return data;

}

export const updateUserById = async ({
  email,
  password,
  defaultRole,
  roles,
  displayName,
  user_id,
  disabled,
  updated_by,
  send_verification
}: {
  email: string;
  password: string;
  defaultRole: string;
  displayName: string;
  user_id: string;
  disabled: boolean;
  updated_by: any;
  roles: string[];
  send_verification: boolean

}) => {

  let QUERY = gql`mutation update {
  updateUsers(where: {id:{_eq:"${user_id}"}},_set:{defaultRole:"${defaultRole}",displayName:"${displayName}",email:"${email}",disabled:${disabled}}){
    returning{
      id
    }
  }
}
`;
  const { data, error } = await nhost.graphql.request(QUERY);
  if (error) {
    return Promise.resolve(error);
  }
  else {
    changeUserRoles(user_id, roles)
    if (send_verification) {
      nhost.auth.sendVerificationEmail({
        email: email,
        options: {
          // redirectTo: 'https://centa-ams1-dev.netlify.app/login'
        },
      })
    }
    // updateUserRoles(user_id, defaultRole,updatedBy)
    return Promise.resolve("OK");
  }
};
export const changeUserRoles = async (user_id: string, roles: string[]) => {
  deleteUserRolesByUser(user_id).then((resp: any) => {
    roles.length > 0 && roles?.map((item: any) => {
      updateUserRole(user_id, item).then((res: any) => {

      })
    })

  })

}
export const deleteUserRolesByUser = async (user_id: string) => {
  let QUERY = gql`mutation deleteUserRolesByUser {
   deleteAuthUserRoles(where:{userId:{_eq:"${user_id}"}}){
    affected_rows
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const updateUsersById = async ({
  email,
  password,
  displayName,
  user_id,
}: {
  email: string;
  password: string;
  displayName: string;
  user_id: string;
}) => {

  let QUERY = gql`mutation update {
  updateUsers(where: {id:{_eq:"${user_id}"}},_set:{displayName:"${displayName}",email:"${email}",}){
    returning{
      id
    }
  }
}
`;
  const { data, error } = await nhost.graphql.request(QUERY);
  if (error) {
    return Promise.resolve(error);
  }
  else {
    // updateUserRole(user_id, email )
    return Promise.resolve("OK");
  }
};
export const changePassword = async (newPassword: string) => {
  const { error } = await nhost.auth.changePassword({
    newPassword: newPassword
  })
  if (error) {
    return Promise.resolve(error?.message);
  } else {
    return Promise.resolve("OK");
  }
};
export const resetPassword = async ({
  email,
}: {
  email: string;
}) => {
  const { error } = await nhost.auth.resetPassword({
    email: email,
    options: {
      redirectTo: `${process.env.REACT_APP_PRODUCTION_URL}/changepassword`
    },
  })
  if (error) {
    return Promise.resolve(error?.message);
  } else {
    return Promise.resolve("OK");
  }
};
export const getMultipleUsers = async (ids: any) => {

  let QUERY = gql`
  query u{
  users(where:{id:{_in:${ids}}}){
    id
    displayName
  }
}`;
  const { data } = await nhost.graphql.request(QUERY);
  return data;
}
export const insertMultiple = async (objects: any) => {
  let QUERY = gql`
  mutation add_test_events{
  insert_test_events(objects:${(objects)}){
   affected_rows
  }
}`;
  const { data } = await nhost.graphql.request(QUERY);
  return data;
}
export const resendVerificationMail = async (email: string) => {
  console.log({ email })

  nhost.auth.sendVerificationEmail({
    email: email,
    options: {
      redirectTo: `${process.env.REACT_APP_PRODUCTION_URL}/changepassword`
    }

  })
  return true




  // await  nhost.auth.sendVerificationEmail({
  //     email: email,
  //     options: {
  //       redirectTo: `${process.env.REACT_APP_PRODUCTION_URL}/changepassword`
  // },})
}
//updating user ai_permission
export const updateAiPermission = async (userId: string, permission: boolean) => {
  try {
    const QUERY = gql`
  mutation update{
  updateUsers(where:{id:{_eq:"${userId}"}},_set:{ai_permission:${permission}}){
   returning{
      id
    }
  }
  }
  `
    const { error, data } = await nhost.graphql.request(QUERY)
    console.log(error, 'errror is this')
    return data
  } catch (err) {
    console.log(err)
    return false
  }
}